import {Component, Input, Renderer, ElementRef, EventEmitter, Output, AfterViewInit, ViewChild, ViewChildren, QueryList} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';

// import {MdInkBar, MdTabNavBar} from '@angular/material';

import {PerfService} from '../../services/perf.service';


declare var window: any;


@Component({
	selector: 'itd-toolbar',
	templateUrl: './itd-toolbar.component.html',
	styleUrls: ['./itd-toolbar.component.scss']
})
export class ItdToolbarComponent implements AfterViewInit {
	constructor(
		private elementRef: ElementRef,
		private renderer: Renderer,
		private router: Router,

		// private log: LogService
		private perf: PerfService
	) {}

	// @ViewChildren(MdInkBar) inkBars: QueryList<MdInkBar>;
	// @ViewChildren(MdTabNavBar) tabBars: QueryList<MdTabNavBar>;


	@Input()
	tabLinks = [
	];
	activeLinkIndex = 0;


	@Input()
	tabs: any = [];

	@Input()
	showFirst = false;

	@Input()
	showSecond = false;

	// @Input()
	// firstIndex = 0;

	// @Input()
	// secondIndex = 0;


	@Input() color = '';


	// @Input() tabs: any = [];


	@Input() showMore: boolean;
	@Input() isWatch = true;
	@Output() editTheFilm = new EventEmitter();
	@Output() reviewTheFilm = new EventEmitter();



	ngAfterViewInit() {

		const inkBars = this.elementRef.nativeElement.getElementsByTagName('mat-ink-bar');

		// const inkBars = window.document.getElementsByTagName('md-ink-bar');
		// console.log(inkBars);

		if (inkBars && inkBars[0]) {
			inkBars[0].style.backgroundColor = 'white';
		}


		// list.getElementsByTagName("LI")[0].innerHTML = "Milk";





		// console.log(this.inkBars);
		// console.log(this.tabBars);

		// this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
		// 	console.log(mdTabNavBar);

		// 	// if (mdTabNavBar && mdTabNavBar._inkBar && mdTabNavBar._inkBar._elementRef && mdTabNavBar._inkBar._elementRef.nativeElement) {
		// 	// 	const element = mdTabNavBar._inkBar._elementRef.nativeElement;
		// 	// 	console.log(mdTabNavBar._inkBar);
		// 	// }

		// });


		// setTimeout(() => {
		// 	console.log('this.inkBars');
		// 	console.log(this.inkBars);


		// 	console.log('this.tabBars');
		// 	console.log(this.tabBars);
		// 	this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
		// 		console.log(mdTabNavBar);
		// 	});
		// 	if (this.tabBars && this.tabBars[0]) {
		// 		console.log('this.tabBars[0]');
		// 		const tabBar = this.tabBars[0];
		// 		console.log('tabBar');

		// 		if (tabBar && tabBar._inkBar) {
		// 			console.log('tabBar._inkBar');
		// 			console.log(tabBar._inkBar);

		// 		}
		// 	}


		// }, 3000);


	}


	// !!! TODO - NOPE!!!
/*
	onResize(event: any) {
		// console.log('ItdToolbarComponent onResize');
		this.updateInkBar();

		// console.log('onResize. showFirst=' + this.showFirst + ', showSecond=' + this.showSecond);

		// console.log(this.tabBars);
		// this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
		// 	console.log(mdTabNavBar);

		// 	mdTabNavBar.updateInkBar();

		// 	// let inkBar = mdTabNavBar._inkBar;
		// 	// // inkBar.hide();
		// 	// // inkBar.show();
		// });

	}
*/


/*
	updateInkBar() {
		// !!! no longer needed as of 2.0.0-beta.5 !!!


		// console.log('ItdToolbarComponent updateInkBar');
		// this.tabBars.forEach((mdTabNavBar: MdTabNavBar) => {
		this.tabBars.forEach((mdTabNavBar: any) => {
			// mdTabNavBar.updateInkBar();

			// // //mdTabNavBar._alignInkBar();

		});
	}
*/


	firstMenuBarClick(firstTab) {
		if (!this.tabs) {
			console.log('firstMenuBarClick error, no tabs');
			return;
		}

		console.log('firstMenuBarClick');
		console.log(firstTab);

		// let authString = this.profileTabs[index].auth;
		// authString = authString.slice(4);
		this.perf.markUserActionStart(firstTab.name.toLowerCase() + '.clicked');


		let firstIndex = this.tabs.firstIndex;
		// console.log('firstIndex');
		// console.log(firstIndex);

		let secondIndex = this.tabs.firstTabs[this.tabs.firstIndex].secondTab.index;
		// console.log('secondIndex');
		// console.log(secondIndex);


		let theRealTabs = JSON.stringify(this.tabs, null, 2);
		// console.log('theRealTabs');
		// console.log(theRealTabs);
		// console.log('this.tabs');
		// console.log(this.tabs);
		// console.log('this.tabs.firstTabs[this.tabs.firstIndex].secondTab');
		// console.log(this.tabs.firstTabs[this.tabs.firstIndex].secondTab);

		let link = this.tabs.firstTabs[this.tabs.firstIndex].secondTab.tabs[secondIndex].link;
		// console.log('link');
		// console.log(link);

		this.router.navigate([link]);
	}


	secondMenuBarClick(secondTab) {
		if (!this.tabs) {
			console.log('secondMenuBarClick error, no tabs');
			return;
		}

		// console.log('secondMenuBarClick');
		// console.log(secondTab);

		// let authString = this.profileTabs[index].auth;
		// authString = authString.slice(4);
		this.perf.markUserActionStart(secondTab.link.replace(/\//g, '.') + '.clicked');
	}


	getSecondBarTabs(theTabs: any) {
		// tabs?.firstTabs[tabs?.firstIndex]?.secondTab?.tabs
		let secondBarTabs = [];

		if (!this.tabs || !this.tabs.firstTabs) {
			return secondBarTabs;
		}

		let firstIndex = this.tabs.firstIndex || 0;
		let firstBarTabObject = this.tabs.firstTabs[firstIndex];

		if (!firstBarTabObject || !firstBarTabObject.secondTab || !firstBarTabObject.secondTab.tabs) {
			return secondBarTabs;
		}

		secondBarTabs = firstBarTabObject.secondTab.tabs;
		return secondBarTabs;
	}


	getSecondBarTabIndex(theTabs: any) {
		// tabs?.firstTabs[tabs?.firstIndex]?.secondTab?.index
		let secondBarTabIndex = 0;

		if (!this.tabs || !this.tabs.firstTabs) {
			return secondBarTabIndex;
		}

		let firstIndex = this.tabs.firstIndex || 0;
		let firstBarTabObject = this.tabs.firstTabs[firstIndex];

		if (!firstBarTabObject || !firstBarTabObject.secondTab) {
			return secondBarTabIndex;
		}

		secondBarTabIndex = firstBarTabObject.secondTab.index;
		return secondBarTabIndex;
	}


	setSecondBarTabIndex(theTabs: any, index: any) {
		// tabs.firstTabs[tabs.firstIndex].secondTab.index = j
		if (!this.tabs || !this.tabs.firstTabs) {
			return;
		}

		let firstIndex = this.tabs.firstIndex || 0;
		let firstBarTabObject = this.tabs.firstTabs[firstIndex];

		if (!firstBarTabObject || !firstBarTabObject.secondTab) {
			return;
		}

		firstBarTabObject.secondTab.index = index;
		return;
	}



}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/itd-toolbar/itd-toolbar.component.ts